
  <app-navbar-style-two *ngIf="dynamicStatus"></app-navbar-style-two>
  <div align="center" *ngIf="gifLoader">
    <img height="200px" width="200px"
        src="https://medeilpos.blob.core.windows.net/posimage/loading.gif" alt="medeil gif"
        loading="lazy">
   </div>
  <section>
    <div class="container">
      <div class="cs_cta text-center position-relative" [ngStyle]="{'background': pageData?.main_color || '#000'}">
        <div class="cs_cta_in">
          <div class="cs_section_heading cs_style_1">
            <h1 class="cs_section_title cs_text_white">{{ pageData.banner_header }}</h1>
            <p class="cs_section_subtitle mb-0">{{ pageData.banner_sub_content }}</p>
          </div>
          <div class="cs_btn_group text-center">
          <a *ngIf="pageData.cta_button_one && !pageData.togglecontrol" [href]="pageData.cta_button_link_one" class="cs_btn cs_bg_white"
            [ngStyle]="{'color': pageData.sub_color}">
             {{ pageData.cta_button_name_one }}
         </a>
          <a *ngIf="pageData.cta_button_one && pageData.togglecontrol" (click)="openLandingpage(pageData.lead_source_name)" class="cs_btn cs_bg_white"
            [ngStyle]="{'color': pageData.sub_color}">
             {{ pageData.cta_button_name_one }}
         </a>

         <a *ngIf="pageData.cta_button_two && !pageData.togglecontrol_cta_2"  [href]="pageData.cta_button_link_two" class="cs_btn cs_bg_accent"
            [ngStyle]="{'background': pageData.sub_color, 'border-color': pageData.sub_color}">
             {{ pageData.cta_button_name_two }}
         </a>
         <a *ngIf="pageData.cta_button_two && pageData.togglecontrol_cta_2" (click)="openLandingpage(pageData.lead_source_name_cta_2)" class="cs_btn cs_bg_accent"
            [ngStyle]="{'background': pageData.sub_color, 'border-color': pageData.sub_color}">
             {{ pageData.cta_button_name_two }}
         </a>

          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="cs_business_feature position-relative" id="features">
    <div class="container">
      <div class="cs_section_heading cs_style_1 text-center">
        <h2 class="cs_section_title1">{{ pageData.feature_heading }}</h2>
      </div>
      <div class="row justify-content-center">
        <div *ngFor="let feature of pageData.feature" class="col-12 col-sm-6 col-md-4 col-lg-3 d-flex mt-3">
          <div class="cs_iconbox cs_style_1 w-100">
            <div class="cs_iconbox_icon">
              <i class="fa" [ngClass]="feature.feature_icon || 'fa-shopping-cart'" [ngStyle]="{'color': pageData.sub_color}"></i>
            </div>
            <h3 class="cs_iconbox_title">{{ feature.feature_sub_heading }}</h3>
            <p class="cs_iconbox_subtitle">{{ feature.feature_description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- <section class="feature_main_content">
    <div class="container">
      <div  [innerHTML]="pageData.feature_content"></div>
    </div>
  </section> -->

  <section class="cs_faq_wrap position-relative" id="faq">
    <div class="container">
      <div class="feature-content-wrapper" [innerHTML]="pageData.feature_content"></div>
      <div class="cs_section_heading cs_style_1 text-center">
        <h2 class="cs_section_title1 mb-0">{{ pageData.faq_heading }}</h2>
      </div>
      <div class="row">
        <div class="col-xl-10 offset-xl-1 col-lg-10 offset-lg-1">
          <div class="cs_accordian_wrap">
            <div *ngFor="let faq of pageData.faq; let i = index" class="cs_accordian" [class.active]="activeIndex === i">
              <h4 class="cs_accordian_title" (click)="toggleFAQ(i)">
                {{ faq.quetion }}
                <span class="cs_accordian_toggle" [class.rotate]="activeIndex === i"></span>
              </h4>
              <div class="cs_accordian_body" [style.display]="activeIndex === i ? 'block' : 'none'">
                {{ faq.answer }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section>
    <div class="container">
      <div
        class="bottom_cta_panel"
        [ngStyle]="{'background': pageData?.main_color || '#000'}">

        <!-- Left Content -->
        <div class="left-content cs_text_white">
          <p>{{ pageData?.bottom_cta_description }}</p>
        </div>

        <!-- Right Button -->
        <div class="right-button">
          <a *ngIf="!pageData.togglecontrol_cta_3"
            [href]="pageData?.bottom_cta_button_link"
            class="cs_btn cs_bg_accent"
            [ngStyle]="{'background': pageData?.sub_color, 'border-color': pageData?.sub_color}">
            {{ pageData?.bottom_cta_button_name }}
          </a>
          <a *ngIf="pageData.togglecontrol_cta_3"
          (click)="openLandingpage(pageData.lead_source_name_cta_3)"
            class="cs_btn cs_bg_accent"
            [ngStyle]="{'background': pageData?.sub_color, 'border-color': pageData?.sub_color}">
            {{ pageData?.bottom_cta_button_name }}
          </a>
        </div>

      </div>
    </div>
  </section>



  <app-footer-style-two *ngIf="dynamicStatus"></app-footer-style-two>
